import type React from 'react';
import { IsolatedReportPreview } from './IsolatedReportPreview';
import { colors } from '../theme/colors';

interface IsolatedReportPreviewAllProps {
  employees: { employeeId: string; employeeName: string }[];
  projectNumber: string;
  projectName: string;
  month: string;
  selectedOrder?: string;
  customOrderNumber?: string;
  onBack: () => void;
}

export const IsolatedReportPreviewAll: React.FC<IsolatedReportPreviewAllProps> = ({
  employees,
  projectNumber,
  projectName,
  month,
  selectedOrder = '',
  customOrderNumber = '',
  onBack,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '2rem 0',
        gap: '2rem',
      }}
    >
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-start',
          marginBottom: '-0.5rem',
        }}
      >
        <button
          onClick={onBack}
          style={{
            backgroundColor: colors.neutral.grey[400],
            color: colors.neutral.white,
            border: 'none',
            borderRadius: '6px',
            padding: '0.5rem 1rem',
            fontSize: '0.875rem',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          Back
        </button>
      </div>
      {employees.map(({ employeeId, employeeName }) => (
        <IsolatedReportPreview
          key={employeeId}
          projectNumber={projectNumber}
          projectName={projectName}
          month={month}
          employeeId={employeeId}
          employeeName={employeeName}
          selectedOrder={selectedOrder}
          customOrderNumber={customOrderNumber}
          onBack={() => {}}
          showBackButton={false}
        />
      ))}
    </div>
  );
};
